module.exports = __webpack_public_path__ + "img/finish-heather-willow.56c4f4fb.jpg";